<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'bankAccountAdd',
    components: {
      baseEdit,
    },
  };
</script>
